import "./styles.scss"
import './theme/default.scss';

export { default as DateRange } from './components/DateRange';
export { default as Calendar } from './components/Calendar';
export { default as DateRangePicker } from './components/DateRangePicker';
export { default as DefinedRange } from './components/DefinedRange';
export { defaultInputRanges, defaultStaticRanges, createStaticRanges } from './defaultRanges';